import React, { forwardRef } from "react";
import { MDBInput } from "mdb-react-ui-kit";

const InputField = forwardRef(({ type = "text", ...restProps }, ref) => {
    return <MDBInput ref={ref} type={type} {...restProps} size="sm" />;
});

InputField.displayName = "InputField";

export default InputField;


